<app-nav [home]="image_header_presence">

  <div [ngClass]="{'home-hide': image_header_presence}">
    <div class="breadcrumb-parent">
      <breadcrumb #parent>
        <span class="breadcrumb" *ngFor="let route of parent.breadcrumbs">
            <a class="previous-page" *ngIf="!route.terminal" href="" [routerLink]="[route.url]">{{ route.displayName | translate }}</a>
            <a class="actual-page" *ngIf="route.terminal">{{ route.displayName | translate }}</a>
        </span>
      </breadcrumb>
    </div>
    <div class="below-breadcrumb"></div>
  </div>

  <div class="page-container">
    <router-outlet></router-outlet>
  </div>

  <footer>
    <p>{{ 'footer' | translate }}</p>
    <div class="footer-logos">
      <a href="https://unione-italiana.eu/index.php/it/">
        <img src="../assets/footer/UI_bianco.png" class="ui-logo-footer" [alt]="'about.partner.primis.ui' | translate" [title]="'about.partner.primis.ui' | translate">
      </a>
      <a href="http://www.regione.fvg.it/rafvg/cms/RAFVG/">
        <img src="../assets/footer/friuli.png" class="friuli-logo-footer" [alt]="'about.partner.primis.friuli' | translate" [title]="'about.partner.primis.friuli' | translate">
      </a>
      <a href="https://www.regione.veneto.it/web/guest/home">
        <img src="../assets/footer/veneto.png" class="veneto-logo-footer" [alt]="'about.partner.primis.veneto' | translate" [title]="'about.partner.primis.veneto' | translate">
      </a>
      <a href="https://www.gov.si/drzavni-organi/vladne-sluzbe/sluzba-vlade-za-razvoj-in-evropsko-kohezijsko-politiko/">
        <img src="../assets/footer/tourism_slo_bianco.png" class="slo-logo-footer" [alt]="'about.partner.primis.slo' | translate" [title]="'about.partner.primis.slo' | translate">
      </a>
    </div>
    <div class="footer-logos-small">
      <a href="https://unione-italiana.eu/index.php/it/">
        <img src="../assets/footer/UI_s_bianco.png" class="ui-logo-footer-small" [alt]="'about.partner.primis.ui' | translate" [title]="'about.partner.primis.ui' | translate">
      </a>
      <a href="http://www.regione.fvg.it/rafvg/cms/RAFVG/">
        <img src="../assets/footer/friuli_s.png" class="friuli-logo-footer-small" [alt]="'about.partner.primis.friuli' | translate" [title]="'about.partner.primis.friuli' | translate">
      </a>
      <a href="https://www.regione.veneto.it/web/guest/home">
        <img src="../assets/footer/veneto_s.png" class="veneto-logo-footer-small" [alt]="'about.partner.primis.veneto' | translate" [title]="'about.partner.primis.veneto' | translate">
      </a>
      <a href="https://www.gov.si/drzavni-organi/vladne-sluzbe/sluzba-vlade-za-razvoj-in-evropsko-kohezijsko-politiko/">
        <img src="../assets/footer/tourism_slo_s_bianco.png" class="slo-logo-footer-small" [alt]="'about.partner.primis.slo' | translate" [title]="'about.partner.primis.slo' | translate">
      </a>
    </div>

    <div class="footer-logos">
      <a href="https://www.ita-slo.eu/it/primis">
        <img src="../assets/footer/ATS_blu.png" class="ui-logo-footer" [alt]="'about.partner.primis.ats' | translate" [title]="'about.partner.primis.ats' | translate">
      </a>
      <a href="https://cancostiera.eu/it/">
        <img src="../assets/footer/CAN.png" class="friuli-logo-footer" [alt]="'about.partner.primis.can' | translate" [title]="'about.partner.primis.can' | translate">
      </a>
      <a href="https://www.sdgz.it/">
        <img src="../assets/footer/SDGZ.png" class="veneto-logo-footer" [alt]="'about.partner.primis.sdgz' | translate" [title]="'about.partner.primis.sdgz' | translate">
      </a>
      <a href="https://www.rra-zk.si/en">
        <img src="../assets/footer/RDA.png" class="slo-logo-footer" [alt]="'about.partner.primis.rda' | translate" [title]="'about.partner.primis.rda' | translate">
      </a>
    </div>
    <div class="footer-logos-small">
      <a href="https://www.ita-slo.eu/it/primis">
        <img src="../assets/footer/ATS_s_blu.png" class="ui-logo-footer-small" [alt]="'about.partner.primis.ats' | translate" [title]="'about.partner.primis.ats' | translate">
      </a>
      <a href="http://cancostiera.org/">
        <img src="../assets/footer/CAN_s.png" class="friuli-logo-footer-small" [alt]="'about.partner.primis.can' | translate" [title]="'about.partner.primis.can' | translate">
      </a>
      <a href="https://www.sdgz.it/">
        <img src="../assets/footer/SDGZ_s.png" class="veneto-logo-footer-small" [alt]="'about.partner.primis.sdgz' | translate" [title]="'about.partner.primis.sdgz' | translate">
      </a>
      <a href="https://www.rra-zk.si/en">
        <img src="../assets/footer/RDA_s.png" class="slo-logo-footer-small" [alt]="'about.partner.primis.rda' | translate" [title]="'about.partner.primis.rda' | translate">
      </a>
    </div>

    <div class="footer-logos">
      <a href="https://www.fondazionecomelico.it/">
        <img src="../assets/footer/comelico.png" class="ui-logo-footer" [alt]="'about.partner.primis.comelico' | translate" [title]="'about.partner.primis.comelico' | translate">
      </a>
      <a href="https://www.vegal.net/">
        <img src="../assets/footer/vegal.png" class="slo-logo-footer" [alt]="'about.partner.primis.vegal' | translate" [title]="'about.partner.primis.vegal' | translate">
      </a>
      <!-- nuovi loghi -->
      <a href="https://inv.si/predstavitev/">
        <img src="../assets/footer/inv.png" class="slo-logo-footer" [alt]="'about.partner.primis_plus.ise' | translate" [title]="'about.partner.primis_plus.ise' | translate">
      </a>
      <a href="https://www.filologicafriulana.it/">
        <img src="../assets/footer/sff.png" class="slo-logo-footer" [alt]="'about.partner.primis_plus.sff' | translate" [title]="'about.partner.primis_plus.sff' | translate">
      </a>
    </div>
    <div class="footer-logos-small">
      <a href="https://inv.si/predstavitev/">
        <img src="../assets/footer/inv_s.png" class="ui-logo-footer-small" [alt]="'about.partner.primis_plus.ise' | translate" [title]="'about.partner.primis_plus.ise' | translate">
      </a>
      <a href="https://www.filologicafriulana.it/">
        <img src="../assets/footer/sff_s.png" class="slo-logo-footer-small" [alt]="'about.partner.primis_plus.sff' | translate" [title]="'about.partner.primis_plus.sff' | translate">
      </a>
      <!-- nuovi loghi -->
      <a href="http://www.fondazionecst.info/">
        <img src="../assets/footer/comelico_s.png" class="ui-logo-footer-small" [alt]="'about.partner.primis.comelico' | translate" [title]="'about.partner.primis.comelico' | translate">
      </a>
      <a href="https://www.vegal.net/">
        <img src="../assets/footer/vegal_s.png" class="slo-logo-footer-small" [alt]="'about.partner.primis.vegal' | translate" [title]="'about.partner.primis.vegal' | translate">
      </a>
    </div>

  </footer>
  <div class="version-section">
    Almaviva @ Version {{version}}
  </div>

  <app-loading-overlay [loading]="loading"></app-loading-overlay>

</app-nav>
